import { debugError } from "@/core/utils/print-utilts";

export enum CheckoutSessionState {
  Success = "success",
  Canceled = "canceled",
}

export const CHECKOUT_SESSION_STATE = "checkoutSessionState";

export type CheckoutSessionCallbackURL =
  `${string}?${typeof CHECKOUT_SESSION_STATE}=${CheckoutSessionState}`;

export function getCheckoutSessionCallbackURLs(): {
  successUrl: CheckoutSessionCallbackURL;
  cancelUrl: CheckoutSessionCallbackURL;
} {
  try {
    // Get the current URL
    const baseUrl = window.location.href;

    // Create URLs with the appropriate state parameters
    const successUrl = new URL(baseUrl);
    const cancelUrl = new URL(baseUrl);

    successUrl.searchParams.set(CHECKOUT_SESSION_STATE, CheckoutSessionState.Success);
    cancelUrl.searchParams.set(CHECKOUT_SESSION_STATE, CheckoutSessionState.Canceled);

    return {
      successUrl: successUrl.toString() as CheckoutSessionCallbackURL,
      cancelUrl: cancelUrl.toString() as CheckoutSessionCallbackURL,
    };
  } catch (error) {
    debugError("Error constructing checkout session fallback URL: ", error);

    // Fallback to a safe default if URL construction fails
    const fallbackBase = window.location.origin || "https://app.flair.ai";

    return {
      successUrl:
        `${fallbackBase}?${CHECKOUT_SESSION_STATE}=${CheckoutSessionState.Success}` as CheckoutSessionCallbackURL,
      cancelUrl:
        `${fallbackBase}?${CHECKOUT_SESSION_STATE}=${CheckoutSessionState.Canceled}` as CheckoutSessionCallbackURL,
    };
  }
}
